import { CREATE_ORDER } from "../../constants/ActionTypes";

const INIT_STATE = {
  createOderData: null,
};

const createOrderReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_ORDER: {
      return {
        ...state,
        createOderData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default createOrderReducer;
